import { useQuery } from '@tanstack/react-query';
import { punchcardService } from '../services/punchcardService';
import { punchcardKeys } from './queryKeys';
import type { Collect } from '../types';

export function usePunchcardCollects(agreementUuid: string | undefined) {
  return useQuery<Collect[]>({
    queryKey: punchcardKeys.collects(agreementUuid ?? ''),
    queryFn: () => punchcardService.getCollects(agreementUuid!),
    enabled: !!agreementUuid,
  });
}
